import { useTranslations } from 'next-intl';
import { Icon } from '@/components/entities/Sprite';
import BottomSheetModal from '@/components/shared/BottomSheetModal';

interface Props {
  open: boolean;
  onOpenChange: (open: boolean) => void;
}

const BalanceInfoModal = ({ open, onOpenChange }: Props) => {
  const t = useTranslations('header.balance-card');
  return (
    <BottomSheetModal classNamePointer="mb-6" open={open} onOpenChange={onOpenChange}>
      <p className="paragraph-m-regular flex flex-col gap-6">
        <span className="block">
          {t.rich('sweep-coin-info-description', { br: () => <br /> })}
        </span>
        <span className="block">
          {t.rich('sweep-coin-info-description-2', {
            icon: () => <Icon name="sweep-coin" className="inline-block size-5 align-middle -mt-1" />,
            br: () => <br />,
          })}
        </span>
      </p>
    </BottomSheetModal>
  );
};
export default BalanceInfoModal;
